import { React, useEffect, useState } from "react";
import { Header } from "./../Header";
import { Layout } from "./Layout";
import { Link } from "react-router-dom";
import { Sidebar } from "../Sidebar";
import axios from "axios";
import ToastMessage from "../ToastMessage";
import { base_url } from "../../context/Authcontext";
import "bootstrap/dist/css/bootstrap.min.css";
import { HeaderSmall } from "../HeaderSmall";
import "../../assets/AdminCss/register.css";
import toast from "react-hot-toast";
import { useTheme } from "../../context/ThemeContext";
import MarqueeBottom from "../components/MarqueeBottom";
import WhatsAppButton from "../components/WhatsAppButton";
import { formatINR } from "../../utils/money";
import { UsdtWithdraw } from "../components/Usdt";

const handleFooterLink = () => {
  toast.success("Coming Soon!", {
    position: "top-center",
    autoClose: 3000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: "colored",
  });
};
export const Withdraw = () => {
  const [activeBank, setActiveBank] = useState(0);
  const [addaccount, setaddaccount] = useState(false);
  const [existaccount, setexistaccount] = useState(true);
  const [addpinmodal, setaddpinmodal] = useState(false);
  const [amount, setamount] = useState(500);
  const [isSidebar, setSidebar] = useState(false);
  // RB-088: prevent double submit on slow networks
  const [isAddingBank, setIsAddingBank] = useState(false);
  const [isWithdrawing, setIsWithdrawing] = useState(false);
  const [useBankList, setUserBankList] = useState(null);
  const [bankList, setBankList] = useState([]);
  const [withdrawHistory, setWithdrawHistory] = useState(null);
  const [refresh, setRefresh] = useState(false);
  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth < 768);
  const { themeColors } = useTheme();
  const [bankDetails, setBankDetails] = useState({
    Payment_option: "",
    Holder_name: "",
    Bank_name: "",
    Account_number: "",
    ifsc_code: "",
    upiId: "",
  });
  // RB-077/078/079/080 — dynamic Add Account flow.
  // Method is chosen first; only that method's fields render.
  const [withdrawalMethod, setWithdrawalMethod] = useState("");
  const [upiDetails, setUpiDetails] = useState({ upiId: "", provider: "" });
  const [usdtDetails, setUsdtDetails] = useState({
    network: "",
    address: "",
    label: "",
  });

  const [showCanvas, setShowCanvas] = useState(false);

  const handleCanvasShow = () => setShowCanvas(true);
  const handleCanvasClose = () => setShowCanvas(false);

  useEffect(() => {
    const handleResize = () => {
      setIsSmallScreen(window.innerWidth < 768);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  const handleChange = (e) => {
    const { name, value } = e.target;
    let nextValue = value;
    if (name === "Account_number") {
      nextValue = String(value).replace(/\s+/g, "");
    } else if (name === "ifsc_code") {
      nextValue = String(value).replace(/\s+/g, "").toUpperCase();
    }
    setBankDetails((prev) => ({
      ...prev,
      [name]: nextValue,
    }));
  };
  // Router: dispatches to the right backend endpoint based on withdrawalMethod.
  const handleAddAccountSubmit = async (e) => {
    e.preventDefault();
    if (isAddingBank) return;
    if (!withdrawalMethod) {
      ToastMessage(0, "Please select a withdrawal option");
      return;
    }
    if (withdrawalMethod === "BANK") return handleSubmit(e);
    if (withdrawalMethod === "UPI") return handleAddUpiSubmit(e);
    if (withdrawalMethod === "USDT") return handleAddUsdtSubmit(e);
  };

  const handleAddUpiSubmit = async (e) => {
    e.preventDefault?.();
    if (!upiDetails.upiId || !/^[\w.\-]{2,}@[A-Za-z]{2,}$/.test(upiDetails.upiId)) {
      ToastMessage(0, "Enter a valid UPI ID (e.g. yourname@upi)");
      return;
    }
    setIsAddingBank(true);
    try {
      const res = await axios.post(
        `${base_url}/api/webapi/withdraw/add_upi`,
        { upiId: upiDetails.upiId, provider: upiDetails.provider },
        { withCredentials: true, timeout: 30000, headers: { Accept: "application/json" } }
      );
      setRefresh(!refresh);
      if (res.data.status) {
        setexistaccount(!existaccount);
        setaddaccount(!addaccount);
        ToastMessage(1, res.data.message || "UPI added");
      } else {
        ToastMessage(0, res.data.message || "Could not save UPI");
      }
    } catch (err) {
      ToastMessage(0, err?.code === "ECONNABORTED" ? "Request timed out — please try again" : "error");
    } finally {
      setIsAddingBank(false);
    }
  };

  const handleAddUsdtSubmit = async (e) => {
    e.preventDefault?.();
    if (!usdtDetails.network) {
      ToastMessage(0, "Please select a network");
      return;
    }
    if (!usdtDetails.address) {
      ToastMessage(0, "Wallet address is required");
      return;
    }
    if (usdtDetails.network === "TRC20" && !/^T[A-Za-z0-9]{33}$/.test(usdtDetails.address)) {
      ToastMessage(0, "TRC20 address must start with T and be 34 characters");
      return;
    }
    if (
      (usdtDetails.network === "ERC20" || usdtDetails.network === "BEP20") &&
      !/^0x[A-Fa-f0-9]{40}$/.test(usdtDetails.address)
    ) {
      ToastMessage(0, `${usdtDetails.network} address must start with 0x and be 42 characters`);
      return;
    }
    setIsAddingBank(true);
    try {
      const res = await axios.post(
        `${base_url}/api/webapi/withdraw/add_usdt_address`,
        {
          mainNetwork: usdtDetails.network,
          usdtAddress: usdtDetails.address,
          addressAlias: usdtDetails.label || `${usdtDetails.network} wallet`,
        },
        { withCredentials: true, timeout: 30000, headers: { Accept: "application/json" } }
      );
      setRefresh(!refresh);
      if (res.data.status) {
        setexistaccount(!existaccount);
        setaddaccount(!addaccount);
        ToastMessage(1, res.data.message || "USDT address added");
      } else {
        ToastMessage(0, res.data.message || "Could not save USDT address");
      }
    } catch (err) {
      ToastMessage(0, err?.code === "ECONNABORTED" ? "Request timed out — please try again" : "error");
    } finally {
      setIsAddingBank(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (isAddingBank) return; // dedupe
    // console.log(bankDetails, "posting bankdetails");
    if (
      !bankDetails.Payment_option ||
      !bankDetails.Holder_name ||
      !bankDetails.Bank_name ||
      !bankDetails.Account_number ||
      !bankDetails.ifsc_code ||
      !bankDetails.ifsc_code
    ) {
      ToastMessage(0, "All fields are required");
      return;
    }
    if (!/^[A-Za-z0-9]{6,25}$/.test(bankDetails.Account_number)) {
      ToastMessage(0, "Account Number must be 6-25 letters or digits, with no spaces.");
      return;
    }
    if (!/^[A-Z]{4}0[A-Z0-9]{6}$/.test(bankDetails.ifsc_code)) {
      ToastMessage(0, "Enter a valid IFSC code (e.g. HDFC0001234).");
      return;
    }
    setIsAddingBank(true);
    try {
      const res = await axios.post(
        `${base_url}/api/webapi/withdraw/add_bank_card`,
        { bankDetails },
        {
          withCredentials: true,
          timeout: 30000,
          headers: {
            Accept: "application/json",
          },
        }
      );
      // console.log('ress',res);
      setRefresh(!refresh);
      if (res.data.status) {
        setexistaccount(!existaccount);
        setaddaccount(!addaccount);
        ToastMessage(1, res.data.message);
      } else {
        ToastMessage(0, res.data.message);
      }
    } catch (err) {
      ToastMessage(0, err?.code === "ECONNABORTED" ? "Request timed out — please try again" : "error");
    } finally {
      setIsAddingBank(false);
    }
  };
  const handleWithdrawChange = (e) => {
    setamount(e.target.value);
  };
  const handleWithdrawSubmit = async (e) => {
    e.preventDefault();
    if (isWithdrawing) return; // dedupe double-clicks
    if (useBankList?.length === 0) {
      ToastMessage(0, "Please Add Bank Account To Withdraw");
      return;
    }

    if (amount < 500) {
      ToastMessage(0, "500 is minimum withdrawal amount");
      return;
    }

    setIsWithdrawing(true);
    try {
      const selected = useBankList && useBankList[activeBank];
      if (!selected) {
        ToastMessage(0, "Please select an account to withdraw to");
        return;
      }

      const withdrawAmount = amount;
      const isUpi = selected.type === "UPI";

      // A UPI account has no IFSC, so it must not be validated like a bank
      // card. Send the method that matches the selected account.
      const payload = isUpi
        ? {
            withdrawalMethod: "UPI",
            upiId: selected.upiId || selected.bankAccountNumber,
            recipientName: selected.recipientName,
            withdrawAmount,
          }
        : {
            withdrawalMethod: "BANK_CARD",
            bankac: selected.bankAccountNumber,
            recipientName: selected.recipientName,
            withdrawAmount,
            bankname: selected.bankName,
            ifsc: selected.IFSC,
          };

      const hasRequiredDetails = isUpi
        ? Boolean(payload.upiId && withdrawAmount)
        : Boolean(
            payload.bankac &&
              payload.recipientName &&
              withdrawAmount &&
              payload.bankname &&
              payload.ifsc
          );

      if (hasRequiredDetails) {
        const res = await axios.post(
          `${base_url}/api/webapi/withdraw/create`,
          payload,
          {
            withCredentials: true,
            headers: {
              Accept: "application/json",
            },
          }
        );
        // console.log("res width", res);
        if (res.data.status === true) {
          ToastMessage(1, res.data.message);
          setamount(500);
          setRefresh(!refresh);
        } else if (res.data.status === false) {
          ToastMessage(0, res.data.message);
        }
      } else {
        console.log("error");
        ToastMessage(0, "All details are required");
      }
    } catch (err) {
      console.log(err);
      ToastMessage(0, "error");
    } finally {
      setIsWithdrawing(false);
    }
  };

  useEffect(() => {
    const fetchBankList = async () => {
      try {
        const res = await axios.get("/bank_list.json");
        let banklist = res.data.data.banklist;

        // sort ascending by bankName (case-insensitive)
        banklist = banklist.sort((a, b) =>
          a.bankName.localeCompare(b.bankName, undefined, {
            sensitivity: "base",
          })
        );

        console.log("banklist (sorted)", banklist);
        setBankList(banklist);
      } catch (err) {
        console.log(err);
      }
    };

    const fetchUserBank = async () => {
      try {
        const res = await axios.post(
          `${base_url}/api/webapi/withdraw/bank_card`,
          {},
          {
            withCredentials: true,
            headers: {
              Accept: "application/json",
            },
          }
        );

        if (res.data.status) {
          setUserBankList(res.data.data);
          if (!Array.isArray(res.data.data) || res.data.data.length === 0) {
            setexistaccount(false);
            setaddaccount(true);
          }
        }
        // console.log(useBankList);
      } catch (err) {
        console.log(err);
      }
    };

    const fetchWithdrawlHistory = async () => {
      try {
        // The config object belongs in the third argument. Passing it as the
        // request body meant the call carried no payload and no credentials.
        const res = await axios.post(
          `${base_url}/api/webapi/withdraw/history`,
          {},
          {
            withCredentials: true,
            headers: {
              Accept: "application/json",
            },
          }
        );
        setWithdrawHistory(res.data.withdrawList || []);
        // console.log("res history", res.data.withdrawList);
      } catch (err) {
        console.log(err);
        // Leave the table in a terminal state instead of a permanent spinner.
        setWithdrawHistory([]);
      }
    };
    fetchUserBank();
    fetchBankList();
    fetchWithdrawlHistory();
  }, [existaccount, refresh]);
  return (
    <>
      <Sidebar isSidebar={isSidebar} setSidebar={setSidebar} />
      <div className="header-large">
        {/* <Header isSidebar={isSidebar} setSidebar={setSidebar} refreshHeader={refresh} /> */}
        <Header
          isSidebar={isSidebar}
          setSidebar={setSidebar}
          show={showCanvas}
          handleShow={handleCanvasShow}
          handleClose={handleCanvasClose}
        />
      </div>
      <div className="header-small">
        <Header
          isSidebar={isSidebar}
          setSidebar={setSidebar}
          show={showCanvas}
          handleShow={handleCanvasShow}
          handleClose={handleCanvasClose}
        />
        {/* <HeaderSmall /> */}
      </div>

      <div
        _ngcontent-hdd-c80=""
        style={{ backgroundColor: "var(--dark-theme-color-navbar)" }}
      >
        <div className="marquee">
          <marquee>
            👉👉🏏WOMEN BIG BASH 2024 PREMIUM MATCH AND FANCY MARKETS ARE
            AVAILABLE. PLAY NOW AND WIN BIG WITH KHELOYAR.🏏.💰GET CASH BONUS ON
            EVERY DEPOSIT 💸..👈👈
          </marquee>
          <app-sitefooter
            _ngcontent-mkq-c100=""
            className="ng-tns-c100-1"
            _nghost-mkq-c94=""
          >
            {/* <div
              _ngcontent-mkq-c94=""
              id="site_footer-settings"
              className="site_footer "
              style={{ display: "block" }}
            >
              <div
                _ngcontent-mkq-c94=""
                style={{ backgroundColor: "grey" }}
                className="site_footer_inn"
              >
                <ul
                  _ngcontent-mkq-c94=""
                  className="nav-bottom-site site-ui-inn"
                >
                 
                  
                 <div style={{width:"99%"}} className="d-flex justify-content-between">
                 <div className="d-flex">
                  <li _ngcontent-mkq-c94="">
                      <Link _ngcontent-mkq-c94="" to="/">
                        <img
                          _ngcontent-mkq-c94=""
                          className="icon-navbar-site"
                          style={{ maxWidth: "18px" }}
                          alt="icon_Kheloyaar360"
                          src="/assets/images/27500.png"
                        />
                      </Link>
                    </li>

                   
                      

                    
                   
                     
                     
                  </div>
                   <div className="d-flex gap-3">
                   <li
                      _ngcontent-mkq-c94=""
                      className="hide-specific ng-star-inserted "
                      tabIndex={0}
                      onClick={handleFooterLink}
                    >
                      <Link _ngcontent-mkq-c94="" className="list-icon-bg">
                        <img
                          src="https://daba.b-cdn.net/bet365exch.in/B.svg"
                          alt=""
                          _ngcontent-mkq-c94=""
                          className="liveCasinoss"
                        />
                      </Link>
                    </li>

                    <li _ngcontent-mkq-c94="">
                      <Link _ngcontent-mkq-c94="" to="/menu">
                        <img
                          _ngcontent-mkq-c94=""
                          className="icon-navbar-site"
                          style={{ maxWidth: "18px" }}
                          alt="icon_Kheloyaar360"
                          src="https://dabba.b-cdn.net/global/menuglobal.svg"
                        />
                      </Link>
                    </li>
                   </div>
                 </div>
                  
                </ul>
              </div>
            </div> */}
          </app-sitefooter>
        </div>
        <app-reports _nghost-hdd-c162="" className="ng-star-inserted">
          <div _ngcontent-hdd-c162="" className="pcoded-main-container">
            <div
              _ngcontent-hdd-c162=""
              className="container-fluid pl-3 accounts-box"
            >
              <div _ngcontent-hdd-c162="" className="row account-tabs">
                {/* <Layout /> */}
                <div
                  _ngcontent-hdd-c162=""
                  className="col-12 mt-2 px-0 centralized_css"
                >
                  <router-outlet _ngcontent-hdd-c162=""></router-outlet>
                  <app-with-draw
                    _nghost-hdd-c174=""
                    className="ng-star-inserted"
                  >
                    <div _ngcontent-hdd-c174="" className="container withdraw">
                      <h3
                        _ngcontent-hdd-c174=""
                        className="text-center mt-2 ng-star-inserted"
                        style={{
                          // Inline "sans-serif" overrode the stylesheet, so
                          // this heading alone rendered in the browser default
                          // face instead of the site's.
                          fontFamily: "var(--rb-font)",
                          color: "var(--dark-theme-white-color)",
                        }}
                      >
                        {" "}
                        Withdraw Request{" "}
                      </h3>

                      <div className="d-flex align-items-center justify-content-center">
                        <ul
                          style={{
                            listStyle: "disc",
                            margin: "10px",
                            fontFamily: "var(--rb-font)",
                            color: "var(--dark-theme-white-color)",
                          }}
                          _ngcontent-hdd-c174=""
                          className="withdraw-text-list ng-star-inserted "
                        >
                          <li>
                            The bonus amount can be used to place bets across
                            the platform and the winnings can be withdrawn.
                          </li>
                          <li>
                            In case of Any withdrawal issue i.e: Late
                            withdrawal, bank issue etc client can complain on
                            withdraw issue whatsapp given below.
                          </li>
                          <li>
                            If the withdrawals are pending from the bank, it may
                            take upto 72 banking hours for your transaction to
                            clear.
                          </li>
                        </ul>
                      </div>
                      <UsdtWithdraw onSubmitted={() => setRefresh((prev) => !prev)} />
                      {/* <div
                        _ngcontent-hdd-c174=""
                        className="d-flex justify-content-center align-items-center withdraw-request"
                      >
                        <p _ngcontent-hdd-c174="">
                          {" "}
                          CLICK HERE TO WITHDRAW IN USDT
                          <br _ngcontent-hdd-c174="" /> CLICK HERE FOR ANY
                          WITHDRAW ISSUE{" "}
                        </p>
                      </div> */}
                      {/* <div
                        _ngcontent-hdd-c174=""
                        className="depositTabsWrapper ng-star-inserted"
                        style={{ paddingTop: "8px" }}
                      >
                        <div
                          _ngcontent-hdd-c174=""
                          className="resetpinbox"
                          onClick={() => setaddpinmodal(true)}
                        >
                          <span _ngcontent-hdd-c174="">
                            CLICK HERE TO RESET WITHDRAW PIN
                          </span>
                        </div>
                      </div> */}
                      <div
                        _ngcontent-hdd-c174=""
                        className="depositTabsWrapper"
                      >
                        <div _ngcontent-hdd-c174="" className="d-flex box my-2">
                          <Link
                            _ngcontent-hdd-c174=""
                            className="option position-relative"
                            onClick={() => {
                              setaddaccount(true);
                              setexistaccount(false);
                            }}
                          >
                            <div
                              _ngcontent-hdd-c174=""
                              className={`${
                                addaccount ? "" : "curvybox curvybox-2"
                              } `}
                            >
                              {" "}
                              Add Account{" "}
                            </div>
                          </Link>
                          <Link
                            _ngcontent-hdd-c174=""
                            className="option position-relative"
                            onClick={() => {
                              setaddaccount(false);
                              setexistaccount(true);
                            }}
                          >
                            <div
                              _ngcontent-hdd-c174=""
                              className={`${existaccount ? "" : "curvybox "} `}
                            >
                              {" "}
                              Existing Account{" "}
                            </div>
                          </Link>
                        </div>
                      </div>
                      {addaccount && (
                        <>
                          <form
                            _ngcontent-hdd-c174=""
                            noValidate=""
                            className=" ng-untouched ng-pristine ng-invalid"
                            style={{ padding: "0 1rem 0 1rem" }}
                            onSubmit={handleAddAccountSubmit}
                          >
                            <div
                              _ngcontent-hdd-c174=""
                              className="row"
                              style={{ justifyContent: "space-around" }}
                            >
                              <div className="col-md-12 input-box input-field">
                                <div className="input-group pl-0">
                                  <span className="d-flex-label">
                                    <label htmlFor="WithdrawalOption" className="text-dark">
                                      Select Withdrawal Option
                                    </label>
                                  </span>
                                  <select
                                    id="WithdrawalOption"
                                    className="filters-xg-dropdown"
                                    style={{ height: "45px" }}
                                    value={withdrawalMethod}
                                    onChange={(e) => setWithdrawalMethod(e.target.value)}
                                  >
                                    <option value="" disabled>
                                      Select Withdrawal Option
                                    </option>
                                    <option value="BANK">Bank Account</option>
                                    <option value="UPI">UPI</option>
                                  </select>
                                </div>
                              </div>
                              {withdrawalMethod === "BANK" && (
                                <>
                              <div className="col-md-12 input-box input-field">
                                <div className="input-group pl-0">
                                  <span className="d-flex-label">
                                    <label htmlFor="PaymentOption" className="text-dark">
                                      Bank
                                    </label>
                                  </span>
                                  <select
                                    id="PaymentOption"
                                    className="filters-xg-dropdown"
                                    name="Payment_option"
                                    style={{ height: "45px" }}
                                    onChange={handleChange}
                                    value={bankDetails.Payment_option}
                                  >
                                    <option value="" disabled>
                                      Select Bank
                                    </option>
                                    {bankList.map((ele, index) => (
                                      <option key={index} value={ele.bankName}>
                                        {ele.bankName}
                                      </option>
                                    ))}
                                  </select>
                                </div>
                              </div>
                              <div className="col-md-12 input-box input-field">
                                <div className="input-group">
                                  <span className="d-flex-label">
                                    <label htmlFor="holdername" className="text-dark">
                                      Account Holder Name
                                    </label>
                                  </span>
                                  <input
                                    id="holdername"
                                    type="text"
                                    className="form-control"
                                    placeholder="Holder Name"
                                    name="Holder_name"
                                    onChange={handleChange}
                                    value={bankDetails.Holder_name}
                                  />
                                </div>
                              </div>
                              <div className="col-md-12 input-box input-field">
                                <div className="input-group">
                                  <span className="d-flex-label">
                                    <label htmlFor="bankname" className="text-dark">
                                      Bank Name
                                    </label>
                                  </span>
                                  <input
                                    id="bankname"
                                    type="text"
                                    className="form-control"
                                    placeholder="Bank Name"
                                    maxLength="20"
                                    name="Bank_name"
                                    onChange={handleChange}
                                    value={bankDetails.Bank_name}
                                  />
                                </div>
                              </div>
                              <div className="col-md-12 input-box input-field">
                                <div className="input-group">
                                  <span className="d-flex-label">
                                    <label htmlFor="accountNo" className="text-dark">
                                      Account Number
                                    </label>
                                  </span>
                                  <input
                                    id="accountNo"
                                    type="text"
                                    className="form-control"
                                    placeholder="Account Number"
                                    name="Account_number"
                                    onChange={handleChange}
                                    maxLength={25}
                                    value={bankDetails.Account_number}
                                  />
                                </div>
                              </div>
                              <div className="col-md-12 input-box input-field">
                                <div className="input-group">
                                  <span className="d-flex-label">
                                    <label htmlFor="ibnifsccode" className="text-dark">
                                      IFSC Code
                                    </label>
                                  </span>
                                  <input
                                    id="ibnifsccode"
                                    type="text"
                                    className="form-control"
                                    placeholder="e.g. HDFC0001234"
                                    name="ifsc_code"
                                    onChange={handleChange}
                                    value={bankDetails.ifsc_code}
                                  />
                                </div>
                              </div>
                                </>
                              )}
                              {withdrawalMethod === "UPI" && (
                                <>
                                  <div className="col-md-12 input-box input-field">
                                    <div className="input-group">
                                      <span className="d-flex-label">
                                        <label className="text-dark">UPI ID</label>
                                      </span>
                                      <input
                                        type="text"
                                        className="form-control"
                                        placeholder="e.g. yourname@upi"
                                        value={upiDetails.upiId}
                                        onChange={(e) =>
                                          setUpiDetails((s) => ({ ...s, upiId: e.target.value }))
                                        }
                                      />
                                    </div>
                                  </div>
                                  <div className="col-md-12 input-box input-field">
                                    <div className="input-group">
                                      <span className="d-flex-label">
                                        <label className="text-dark">UPI Provider (optional)</label>
                                      </span>
                                      <select
                                        className="filters-xg-dropdown"
                                        style={{ height: "45px" }}
                                        value={upiDetails.provider}
                                        onChange={(e) =>
                                          setUpiDetails((s) => ({ ...s, provider: e.target.value }))
                                        }
                                      >
                                        <option value="">Select Provider</option>
                                        <option value="GPay">Google Pay</option>
                                        <option value="PhonePe">PhonePe</option>
                                        <option value="Paytm">Paytm</option>
                                        <option value="BHIM">BHIM</option>
                                        <option value="Other">Other</option>
                                      </select>
                                    </div>
                                  </div>
                                </>
                              )}
                              {withdrawalMethod === "USDT" && (
                                <>
                                  <div className="col-md-12 input-box input-field">
                                    <div className="input-group">
                                      <span className="d-flex-label">
                                        <label className="text-dark">Network</label>
                                      </span>
                                      <select
                                        className="filters-xg-dropdown"
                                        style={{ height: "45px" }}
                                        value={usdtDetails.network}
                                        onChange={(e) =>
                                          setUsdtDetails((s) => ({ ...s, network: e.target.value }))
                                        }
                                      >
                                        <option value="">Select Network</option>
                                        <option value="TRC20">TRC20</option>
                                        <option value="ERC20">ERC20</option>
                                        <option value="BEP20">BEP20 / BSC</option>
                                        <option value="Polygon">Polygon</option>
                                        <option value="Solana">Solana</option>
                                      </select>
                                    </div>
                                  </div>
                                  <div className="col-md-12 input-box input-field">
                                    <div className="input-group">
                                      <span className="d-flex-label">
                                        <label className="text-dark">Wallet Address</label>
                                      </span>
                                      <input
                                        type="text"
                                        className="form-control"
                                        placeholder={
                                          usdtDetails.network === "TRC20"
                                            ? "Starts with T, ~34 characters"
                                            : usdtDetails.network === "ERC20" || usdtDetails.network === "BEP20"
                                            ? "Starts with 0x, 42 characters"
                                            : "Wallet address"
                                        }
                                        value={usdtDetails.address}
                                        onChange={(e) =>
                                          setUsdtDetails((s) => ({ ...s, address: e.target.value }))
                                        }
                                      />
                                    </div>
                                  </div>
                                  <div className="col-md-12 input-box input-field">
                                    <div className="input-group">
                                      <span className="d-flex-label">
                                        <label className="text-dark">Wallet Label (optional)</label>
                                      </span>
                                      <input
                                        type="text"
                                        className="form-control"
                                        placeholder="e.g. My Binance wallet"
                                        value={usdtDetails.label}
                                        onChange={(e) =>
                                          setUsdtDetails((s) => ({ ...s, label: e.target.value }))
                                        }
                                      />
                                    </div>
                                  </div>
                                </>
                              )}
                              {/* <div
                                _ngcontent-hdd-c174=""
                                className="col-md-12 input-box input-field"
                              >
                                <div
                                  _ngcontent-hdd-c174=""
                                  className="input-group"
                                >
                                  <span
                                    _ngcontent-hdd-c174=""
                                    className="d-flex-label"
                                  >
                                    <label
                                      _ngcontent-hdd-c174=""
                                      htmlFor="upiId"
                                      className="text-dark"
                                    >
                                      {" "}
                                      Upi Id
                                    </label>
                                    <label _ngcontent-hdd-c174="">
                                      {" "}
                                      Add Upi Id
                                    </label>
                                  </span>
                                  <input
                                    _ngcontent-hdd-c174=""
                                    id="upiId"
                                    type="text"
                                    formcontrolname="upiId"
                                    className="form-control ng-untouched ng-pristine ng-invalid"
                                    placeholder="Enter your Upi id here"
                                    name="upiId"
                                    onChange={handleChange}
                                  />
                                </div>
                              </div> */}
                              <div
                                _ngcontent-hdd-c174=""
                                className="add-account-btn px-0 mt-0"
                              >
                                <div
                                  _ngcontent-hdd-c174=""
                                  className="d-flex w-xl-50 w-100"
                                >
                                  <button
                                    _ngcontent-hdd-c174=""
                                    type="submit"
                                    className="btn btn-info w-100"
                                    disabled={isAddingBank}
                                    aria-busy={isAddingBank}
                                  >
                                    {" "}
                                    {isAddingBank ? "Submitting..." : "Submit"}{" "}
                                  </button>
                                </div>
                              </div>
                            </div>
                          </form>
                        </>
                      )}
                      {existaccount && (
                        <>
                          <div className="bank-account">
                            {useBankList ? (
                              useBankList.map((ele, index) => {
                                return (
                                  <div
                                    key={index}
                                    _ngcontent-hdd-c174=""
                                    className="col-md-10"
                                    style={{ width: "fit-content" }}
                                  >
                                    <div _ngcontent-hdd-c174="" className="row">
                                      <div
                                        _ngcontent-hdd-c174=""
                                        className="col-md-3 mb-0"
                                        style={{ width: "100%" }}
                                      >
                                        <div
                                          _ngcontent-hdd-c174=""
                                          className="card m-3 zoom"
                                          onClick={() => setActiveBank(index)}
                                        >
                                          <div
                                            _ngcontent-hdd-c174=""
                                            className={`${
                                              activeBank === index
                                                ? "d-block"
                                                : "d-none"
                                            } selected`}
                                          >
                                            <img
                                              _ngcontent-hdd-c174=""
                                              alt=""
                                              src="/assets/images/yellow-tick.svg"
                                            />
                                          </div>
                                          <p
                                            _ngcontent-hdd-c174=""
                                            className="text-white"
                                          >
                                            {ele.type === "UPI"
                                              ? "UPI"
                                              : ele.recipientName}
                                          </p>
                                          <p
                                            _ngcontent-hdd-c174=""
                                            className="text-white"
                                          >
                                            {ele.type === "UPI"
                                              ? ele.upiId || ele.bankAccountNumber
                                              : ele.bankAccountNumber}
                                          </p>
                                          <p
                                            _ngcontent-hdd-c174=""
                                            className="text-white"
                                          >
                                            {ele.bankName}
                                          </p>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                );
                              })
                            ) : (
                              <div
                                className="w-100 text-center py-2"
                                style={{
                                  color: "var(--dark-theme-white-color)",
                                }}
                              >
                                Please Add Bank
                              </div>
                            )}
                          </div>
                          <form
                            _ngcontent-hdd-c174=""
                            noValidate=""
                            className="p-4 pt-0 ng-untouched ng-pristine ng-invalid"
                            onSubmit={handleWithdrawSubmit}
                          >
                            <div
                              _ngcontent-hdd-c174=""
                              className="row withDrawSection"
                              style={{
                                justifyContent: "space-around",
                                borderRadius: "5px",
                              }}
                            >
                              <div
                                _ngcontent-hdd-c174=""
                                className="col-md-12 input-box px-0 input-field mb-0"
                              >
                                <div
                                  _ngcontent-hdd-c174=""
                                  className="input-group"
                                >
                                  <span
                                    _ngcontent-hdd-c174=""
                                    className="d-flex-label"
                                  >
                                    <label
                                      _ngcontent-hdd-c174=""
                                      htmlFor="ibnifsccode"
                                      className="text-dark"
                                    >
                                      {" "}
                                      Amount
                                    </label>
                                  </span>
                                  <input
                                    id="ibnifsccode"
                                    type="number"
                                    formcontrolname="ifscCode"
                                    name="Amount"
                                    onChange={handleWithdrawChange}
                                    value={amount}
                                    className="form-control ng-untouched ng-pristine ng-invalid"
                                    placeholder="Amount"
                                  />
                                </div>
                              </div>
                              <div
                                _ngcontent-hdd-c174=""
                                className="withDrawButtons d-flex flex-wrap p-0 mb-0"
                              >
                                {/* <button
                                  _ngcontent-hdd-c174=""
                                  type="button"
                                  onClick={() => setamount(300)}
                                  className={`btn accounts-btn ml-0 mb-0 margin-10 ${
                                    amount === 300 ? "activeAmount" : ""
                                  }`}
                                >
                                  {" "}
                                  300{" "}
                                </button> */}
                                <button
                                  onClick={() => setamount(500)}
                                  _ngcontent-hdd-c174=""
                                  type="button"
                                  className={`btn accounts-btn ml-0 mb-0 margin-10 ${
                                    amount === 500 ? "activeAmount" : ""
                                  }`}
                                >
                                  {" "}
                                  500
                                </button>
                                <button
                                  _ngcontent-hdd-c174=""
                                  type="button"
                                  onClick={() => setamount(5000)}
                                  className={`btn accounts-btn ml-0 mb-0 margin-10 ${
                                    amount === 5000 ? "activeAmount" : ""
                                  }`}
                                >
                                  {" "}
                                  5000{" "}
                                </button>
                                <button
                                  onClick={() => setamount(100000)}
                                  _ngcontent-hdd-c174=""
                                  type="button"
                                  className={`btn accounts-btn ml-0 mb-0 margin-10 ${
                                    amount === 100000 ? "activeAmount" : ""
                                  }`}
                                >
                                  100000{" "}
                                </button>
                                <button
                                  _ngcontent-hdd-c174=""
                                  type="button"
                                  onClick={() => setamount(200000)}
                                  className={`btn accounts-btn ml-0 mb-0 margin-10 ${
                                    amount === 200000 ? "activeAmount" : ""
                                  }`}
                                >
                                  {" "}
                                  200000{" "}
                                </button>
                                <button
                                  onClick={() => setamount(500000)}
                                  _ngcontent-hdd-c174=""
                                  type="button"
                                  className={`btn accounts-btn ml-0 mb-0 margin-10 ${
                                    amount === 500000 ? "activeAmount" : ""
                                  }`}
                                >
                                  500000{" "}
                                </button>
                              </div>
                              <div
                                _ngcontent-hdd-c174=""
                                className="add-account-btn px-0 mt-2"
                              >
                                <div
                                  _ngcontent-hdd-c174=""
                                  className="d-flex w-xl-50 w-100"
                                >
                                  <button
                                    _ngcontent-hdd-c174=""
                                    type="submit"
                                    className="btn btn-info w-100"
                                    disabled={isWithdrawing}
                                    aria-busy={isWithdrawing}
                                  >
                                    {" "}
                                    {isWithdrawing ? "Submitting..." : "Submit"}{" "}
                                  </button>
                                </div>
                              </div>
                            </div>
                          </form>
                          {/* <div
                            _ngcontent-hdd-c174=""
                            className=" ng-star-inserted"
                          >
                            <div
                              _ngcontent-hdd-c174=""
                              className="table-box mt-0"
                              style={{ overflowX: "auto" }}
                            >
                              <table
                                _ngcontent-hdd-c174=""
                                className="table-bordered"
                                style={{ width: "100%" }}
                              >
                                <thead _ngcontent-hdd-c174="">
                                  <th
                                    _ngcontent-hdd-c174=""
                                    className="text-center"
                                  >
                                    Order No.
                                  </th>
                                  <th
                                    _ngcontent-hdd-c174=""
                                    className="text-center"
                                  >
                                    Account Number
                                  </th>
                                  <th
                                    _ngcontent-hdd-c174=""
                                    className="text-center"
                                  >
                                    Amount
                                  </th>
                                  <th
                                    _ngcontent-hdd-c174=""
                                    className="text-center"
                                  >
                                    Status
                                  </th>
                                  <th
                                    _ngcontent-hdd-c174=""
                                    className="text-center"
                                  >
                                    Date&Time
                                  </th>
                                </thead>
                                <tbody _ngcontent-hdd-c174="">
                                  {withdrawHistory !== null ? (
                                    withdrawHistory?.map((ele, index) => {
                                      console.log(ele);
                                      return (
                                        <tr key={index}>
                                          <td className="text-center">
                                            {ele.orderId}
                                          </td>
                                          <td className="text-center">
                                            {ele.bankAccountNumber}
                                          </td>
                                          <td className="text-center">
                                            {ele.amount}
                                          </td>
                                          <td className="text-center">
                                            {ele.status === 0
                                              ? "Pending"
                                              : ele.status === 1
                                              ? "Success"
                                              : "Cancelled"}
                                          </td>
                                          <td className="text-center">
                                            {ele.today}
                                          </td>
                                        </tr>
                                      );
                                    })
                                  ) : (
                                    <div>loading..</div>
                                  )}
                                </tbody>
                              </table>
                            </div>
                          </div> */}
                        </>
                      )}
                    </div>
                    <div className="container-fluid px-3 pb-3" style={{ marginTop: "12px" }}>
                      <div
                        className="d-flex justify-content-between align-items-center mb-2 px-3 py-2 rounded"
                        style={{ background: "var(--dark-theme-dark-blue-variant, #1d2333)" }}
                      >
                        <h6 className="m-0" style={{ color: "#fff", fontWeight: 600 }}>
                          Recent Withdrawals
                        </h6>
                        <Link to="/withdrawhistory" style={{ fontSize: "0.85rem", color: "#9ad7ff" }}>
                          View All
                        </Link>
                      </div>
                      <div className="search-table">
                        <div className="table-box no-more-tables">
                          <table className="table-borderless" style={{ width: "100%", background: "#fff", borderRadius: "6px" }}>
                            <thead>
                              <tr style={{ background: "#f1f3f5" }}>
                                <th className="text-left" style={{ padding: "8px 12px", color: "#333" }}>Amount</th>
                                <th className="text-center" style={{ padding: "8px 12px", color: "#333" }}>Time</th>
                                <th className="text-center" style={{ padding: "8px 12px", color: "#333" }}>Status</th>
                              </tr>
                            </thead>
                            <tbody>
                              {withdrawHistory === null ? (
                                <tr>
                                  <td colSpan="3" className="text-center" style={{ padding: "12px", color: "#666" }}>
                                    Loading...
                                  </td>
                                </tr>
                              ) : withdrawHistory.length === 0 ? (
                                <tr>
                                  <td colSpan="3" className="text-center" style={{ padding: "12px", color: "#666" }}>
                                    No Record Available
                                  </td>
                                </tr>
                              ) : (
                                withdrawHistory.slice(0, 5).map((w, i) => (
                                  <tr key={i} className="xg-bet-tr" style={{ borderTop: "1px solid #eee" }}>
                                    <td className="text-left" data-title="Amount" style={{ padding: "10px 12px", color: "#222" }}>{formatINR(w.amount)}</td>
                                    <td className="text-center" data-title="Time" style={{ padding: "10px 12px", color: "#444" }}>{w.today || w.requestTime}</td>
                                    <td className="text-center p-2" data-title="Status">
                                      <span className={w.status === 1 ? "approved-status" : w.status === 0 ? "" : "rejected-status"}>
                                        {w.status === 0 ? "Pending" : w.status === 1 ? "Success" : "Cancelled"}
                                      </span>
                                    </td>
                                  </tr>
                                ))
                              )}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                    <MarqueeBottom onMenuClick={handleCanvasShow} />
                  </app-with-draw>
                </div>
              </div>
              <WhatsAppButton/>
            </div>
          </div>
        </app-reports>
      </div>
      {/* Withdra password section */}
      {addpinmodal && (
        <>
          <section
            aria-hidden="true"
            style={{ zIndex: "1050" }}
            className="modal-backdrop d-block fade show "
          ></section>
          <section role="dialog" className="changepin d-block modal fade show">
            <div role="document" className="modal-dialog">
              <div className="modal-content">
                <app-createpin _nghost-eov-c172="">
                  <div
                    _ngcontent-hdd-c174=""
                    id="createpin-modal"
                    className="modal modal-content"
                  >
                    <div _ngcontent-hdd-c174="" className="header-top">
                      <Link _ngcontent-hdd-c174="">
                        <img
                          _ngcontent-hdd-c174=""
                          onClick={() => setaddpinmodal(false)}
                          src="/assets/images/cross.svg"
                          alt=""
                        />
                      </Link>
                      <span _ngcontent-hdd-c174="">Create Withdraw PIN</span>
                    </div>
                    <div _ngcontent-hdd-c174="" className="pin-modal-body">
                      <form
                        _ngcontent-hdd-c174=""
                        noValidate=""
                        className="p-4 ng-pristine ng-invalid ng-touched"
                      >
                        <div
                          _ngcontent-hdd-c174=""
                          className="row"
                          style={{ justifyContent: "space-around" }}
                        >
                          <div
                            _ngcontent-hdd-c174=""
                            className="col-md-12 input-box"
                          >
                            <label _ngcontent-hdd-c174="" htmlFor="pin">
                              {" "}
                              Pin
                            </label>
                            <sup
                              _ngcontent-hdd-c174=""
                              style={{ color: "#FF1D1D" }}
                            >
                              *
                            </sup>
                            <div
                              _ngcontent-hdd-c174=""
                              className="input-group pl-0"
                            >
                              <Link _ngcontent-hdd-c174="">
                                <svg
                                  _ngcontent-hdd-c174=""
                                  aria-hidden="true"
                                  className="svg-inline--fa fa-eye fa-w-18"
                                  focusable="false"
                                  data-prefix="fas"
                                  data-icon="eye"
                                  role="img"
                                  xmlns="http://www.w3.org/2000/svg"
                                  viewBox="0 0 576 512"
                                  data-fa-i2svg=""
                                >
                                  <path
                                    fill="currentColor"
                                    d="M572.52 241.4C518.29 135.59 410.93 64 288 64S57.68 135.64 3.48 241.41a32.35 32.35 0 0 0 0 29.19C57.71 376.41 165.07 448 288 448s230.32-71.64 284.52-177.41a32.35 32.35 0 0 0 0-29.19zM288 400a144 144 0 1 1 144-144 143.93 143.93 0 0 1-144 144zm0-240a95.31 95.31 0 0 0-25.31 3.79 47.85 47.85 0 0 1-66.9 66.9A95.78 95.78 0 1 0 288 160z"
                                  ></path>
                                </svg>
                              </Link>
                              <input
                                _ngcontent-hdd-c174=""
                                id="pin"
                                formcontrolname="pin"
                                className="form-control ng-pristine ng-invalid ng-touched"
                                placeholder="Enter PIN"
                                type="password"
                                maxLength="4"
                              />
                            </div>
                          </div>
                          <div
                            _ngcontent-hdd-c174=""
                            className="col-md-12 input-box"
                          >
                            <label _ngcontent-hdd-c174="" htmlFor="confirmPin">
                              {" "}
                              Confirm PIN{" "}
                            </label>
                            <sup
                              _ngcontent-hdd-c174=""
                              style={{ color: "#FF1D1D" }}
                            >
                              *
                            </sup>
                            <div _ngcontent-hdd-c174="" className="input-group">
                              <Link _ngcontent-hdd-c174="">
                                <svg
                                  _ngcontent-hdd-c174=""
                                  aria-hidden="true"
                                  className="svg-inline--fa fa-eye fa-w-18"
                                  focusable="false"
                                  data-prefix="fas"
                                  data-icon="eye"
                                  role="img"
                                  xmlns="http://www.w3.org/2000/svg"
                                  viewBox="0 0 576 512"
                                  data-fa-i2svg=""
                                >
                                  <path
                                    fill="currentColor"
                                    d="M572.52 241.4C518.29 135.59 410.93 64 288 64S57.68 135.64 3.48 241.41a32.35 32.35 0 0 0 0 29.19C57.71 376.41 165.07 448 288 448s230.32-71.64 284.52-177.41a32.35 32.35 0 0 0 0-29.19zM288 400a144 144 0 1 1 144-144 143.93 143.93 0 0 1-144 144zm0-240a95.31 95.31 0 0 0-25.31 3.79 47.85 47.85 0 0 1-66.9 66.9A95.78 95.78 0 1 0 288 160z"
                                  ></path>
                                </svg>
                              </Link>
                              <input
                                _ngcontent-hdd-c174=""
                                id="confirmPin"
                                formcontrolname="confirmPin"
                                className="form-control ng-untouched ng-pristine ng-invalid"
                                placeholder="Enter Confirm PIN"
                                type="password"
                                maxLength="4"
                              />
                            </div>
                          </div>
                        </div>
                        <div
                          _ngcontent-hdd-c174=""
                          className="pin-modal-footer"
                        >
                          <button
                            _ngcontent-hdd-c174=""
                            onClick={() => setaddpinmodal(false)}
                            className="close mdclosebtn"
                          >
                            Close
                          </button>
                          <button
                            _ngcontent-hdd-c174=""
                            type="submit"
                            className="save"
                          >
                            Save
                          </button>
                        </div>
                      </form>
                                          

                    </div>

                  </div>
                </app-createpin>
              </div>
            </div>
          </section>
       
        </>
      )}
    </>
  );
};
